export default class FountainEffect {
	constructor(scene, x, y, texture, duration = 5000, frequency = 100) {
		this.scene = scene;
		this.x = x;
		this.y = y;
		this.texture = texture;
		this.duration = duration;
		this.frequency = frequency;
	}

	start() {
		this.scene.anims.create({
			key: 'spin', // Nome da animação
			frames: this.scene.anims.generateFrameNumbers('coinspin', {
				start: 0,
				end: 5
			}),
			frameRate: 12,
			repeat: -1
		});

		if (this.isRunning) return;

		this.isRunning = true;

		// Configurar evento para gerar partículas
		this.fountainEvent = this.scene.time.addEvent({
			delay: this.frequency,
			callback: () => this.launchParticle(),
			loop: true
		});

		// Parar o efeito após a duração especificada
		this.scene.time.delayedCall(this.duration, () => this.stop());
	}

	launchParticle() {
		const particle = this.scene.add.sprite(this.x, this.y, this.texture);
		particle.postFX.addShine(1, 0.2, 5);
		particle.setScale(0.5);
		particle.depth = 10;

		// Adiciona animação se existir
		if (particle.anims) {
			particle.play('spin');
		}

		// Adiciona física ao sprite
		this.scene.physics.add.existing(particle);
		const body = particle.body;

		// Define velocidade inicial baseada em um ângulo aleatório
		const angle = Phaser.Math.Between(70, 110); // Ângulos para um chafariz vertical
		const speed = Phaser.Math.Between(300, 500); // Velocidade aleatória para o movimento
		const radianAngle = Phaser.Math.DegToRad(angle);

		// Aplica a velocidade com base no ângulo
		body.setVelocity(Math.cos(radianAngle) * speed, -Math.sin(radianAngle) * speed);
		body.setBounce(0.5); // Permite que o objeto quique
		body.setCollideWorldBounds(false); // Faz o objeto colidir com os limites do mundo
		body.setGravityY(300); // Aplica gravidade para puxar os objetos para baixo

		// Destroi o objeto após 5 segundos
		this.scene.time.delayedCall(5000, () => {
			if (particle.active) {
				particle.destroy();
			}
		});
	}

	stop() {
		if (!this.isRunning) return;

		this.isRunning = false;

		// Remove o evento do chafariz
		if (this.fountainEvent) {
			this.fountainEvent.remove(false);
		}
	}
}
